import type { IEntity } from '../../../entities/entitiesUtils'
import { entitiesUtils } from '../../../entities/entitiesUtils-sidecar'
import { l } from '../../../lib/imports'
import { rando } from '../../../lib/rando-sidecar'
import { common } from '../../../main/common-sidecar'
import { chessGameMode_game } from '../chessGameMode_game-sidecar'
import type { EChessTeam } from '../chessPieces'
import { chessPieces } from '../chessPieces-sidecar'
import { chessTilemap } from '../chessTilemap-sidecar'
import type { IChessTilemapPart } from '../chessTilemapPart'
import { chessMessagePieceMoveRequest } from '../messages/chessMessagePieceMoveRequest-sidecar'

export interface IChessAiRando extends IEntity {
  moveTimer: number
  moveTime: number
  team: EChessTeam
  name: string
}

let _objs: IChessAiRando[] = []
export function getAll() {
  return _objs
}

export const spotSize = 32

export function create(
  team: EChessTeam,
  name = 'AI',
  brainSpeed = 1,
): IChessAiRando {
  let obj: IChessAiRando = {
    eType: 'voy-misc',
    id: 0,
    idLoaded: 0,
    isDead: false,
    moveTime: 1 / brainSpeed,
    moveTimer: 0,
    team,
    name,
  }
  _objs.push(obj)
  return obj
}

export function updateAll() {
  l.forEach(getAll(), (c) => {
    update(c)
  })
  entitiesUtils.removeDead(_objs, (c) => {})
}

export function killAll() {
  l.forEach(getAll(), (c) => {
    kill(c)
  })
}
export function kill(obj: IChessAiRando) {
  obj.isDead = true
}

function update(obj: IChessAiRando) {
  let ds = common.getUpdateDeltaScaled()

  if (!chessGameMode_game.getIsGameStarted()) {
    return
  }
  if (!chessGameMode_game.getIsGameStarted()) {
    return
  }

  obj.moveTimer += ds
  if (obj.moveTimer >= obj.moveTime) {
    obj.moveTimer -= rando.fj(obj.moveTime, 0.25)

    // Pick a piece
    let cps = chessPieces.getAll()
    let myPieces = l.filter(
      cps,
      (c) =>
        c.team === obj.team &&
        !c.isDead &&
        c.energy >= chessPieces.getMoveTime(c),
    )

    if (myPieces.length > 0) {
      let cp = rando.sample(myPieces)
      // Find available moves
      let tm = chessTilemap.get()
      let killMoves: IChessTilemapPart[] = []
      let moveMoves: IChessTilemapPart[] = []

      // TODO: defend king
      for (let j = 0; j < tm.height; j++) {
        for (let i = 0; i < tm.width; i++) {
          let tp = chessTilemap.getUnsafe(i, j)

          if (chessTilemap.canMove(cp, tp)) {
            if (tp.pieces.length > 0) {
              killMoves.push(tp) // TODO: prioritize pieces? like king / rook?
            } else {
              moveMoves.push(tp)
            }
          }
        }
      }

      let mtp: IChessTilemapPart | null = null
      if (killMoves.length > 0) {
        mtp = rando.sample(killMoves)
      } else if (moveMoves.length > 0) {
        mtp = rando.sample(moveMoves)
      }

      // TODO: make a move

      if (mtp) {
        chessMessagePieceMoveRequest.sendMessageRequest({
          pieceId: cp.id,
          i: mtp.i,
          j: mtp.j,
        })
      }
    }
  }
}
